import { useEffect, useRef, useState } from "react";
import { Row, Col, Tabs, Card, Breadcrumb, Tooltip, Divider } from "antd";
import { first, isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { configurationString, moduleNameString } from "config/site.string";
import Notifications from "pages/protectedPages/Configuration/Notifications";
import { InfoWrapper } from "pages/protectedPages/ActivityLog/styles";
import { getConfigurationDetailsRequest } from "redux/configuration/actions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store";
import { config } from "config/site.config";
import CustomLoader from "components/common/Loader/CustomLoader";
import { HomeOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SettingsWrapper } from "./styles";

export const Configuration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState<string>("1");
  const childAccessItems = {
    subChildItems: [{ displayText: "Notifications" }],
  };
  const initialized = useRef(false);

  const { loading, configurationDetails, pending } = useSelector(
    (state: RootState) => state.configuration
  );

  const [shouldRefresh, setShouldRefresh] = useState(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      dispatch(getConfigurationDetailsRequest(config.getConfigurationDetails));
    }
  }, [dispatch]);

  useEffect(() => {
    if (shouldRefresh) {
      dispatch(getConfigurationDetailsRequest(config.getConfigurationDetails));
      setShouldRefresh(false);
    }
  }, [shouldRefresh, dispatch]);

  useEffect(() => {
    if (!isEmpty(childAccessItems.subChildItems)) {
      const firstChild = first(childAccessItems.subChildItems) as any;
      setActiveKey(firstChild?.displayText.toUpperCase());
    }
  }, []);

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  const getSubModuleName = () => {
    switch (activeKey) {
      case "1":
        return configurationString.orderNotification;
      case "2":
        return configurationString.invoiceNotification;
      default:
        return configurationString.orderNotification;
    }
  };

  const handleSaveCallback = () => {
    setShouldRefresh(true);
  };

  const displayChildren = (key: string) => {
    switch (key) {
      // case "1":
      //   return <Email configDetails ={configDetails}/>;
      case "1":
        return (
          <Notifications
            configDetails={configurationDetails}
            onSaveCallback={handleSaveCallback}
            agentType="ORDER"
          />
        );
         case "2":
        return (
          <Notifications
            configDetails={configurationDetails}
            onSaveCallback={handleSaveCallback}
            agentType="INVOICE"
          />
        );
      default:
        return null;
    }
  };

  const tabItems = [
    // { key: "1", label: "EMAIL", children: displayChildren("1") },
    { key: "1", label: "ORDER NOTIFICATIONS", children: displayChildren("1") },
     { key: "2", label: "INVOICE NOTIFICATIONS", children: displayChildren("2") },
  ];

  return (
    <SettingsWrapper>
      <InfoWrapper>
        <Breadcrumb
          items={[
            {
              title: <HomeOutlined />,
            //   onClick: () => navigate("/"),
            },
            {
              title: (
                <span style={{ cursor: "pointer" }}>
                  {moduleNameString.configuration}
                </span>
              ),
              onClick: () => {
                navigate("/configuration");
              },
            },
            {
              title: <span>{getSubModuleName()}</span>,
            },
          ]}
        ></Breadcrumb>
        <Tooltip
          title="Configure the email settings for receiving order entry files and set up notifications for successful or failed TMS submissions. This page allows you to manage email configurations and notification preferences efficiently."
          placement="bottomRight"
          overlayInnerStyle={{ maxWidth: 300 }}
        >
          <InfoCircleOutlined style={{ cursor: "pointer" }} />
        </Tooltip>
      </InfoWrapper>
      <Divider style={{ marginBottom: "10px", marginTop: "10px" }} />
      <Row gutter={[30, 30]}>
        <Col xs={24} md={24} xl={24}>
          <Col span={24} style={{ marginTop: 10 }}>
            <div className="page-title">{moduleNameString.configuration}</div>
          </Col>
          <Col span={24}>
            {isEmpty(childAccessItems?.subChildItems) ? (
              <Card className="settings-card-permission">
                {configurationString.noPermission}
              </Card>
            ) : (
              <>
                {(loading || pending) && <CustomLoader />}
                <Tabs
                  defaultActiveKey={activeKey}
                  items={tabItems}
                  onChange={onChange}
                />
              </>
            )}
          </Col>
        </Col>
      </Row>
    </SettingsWrapper>
  );
};

export default Configuration;
